const indexItems = [
  { label: '动作片', icon: 'ri-fire-line', count: '3200+', desc: '热血刺激动作大片' },
  { label: '喜剧片', icon: 'ri-emotion-laugh-line', count: '1800+', desc: '欢乐解压喜剧精选' },
  { label: '爱情片', icon: 'ri-heart-line', count: '2100+', desc: '浪漫动人爱情故事' },
  { label: '悬疑片', icon: 'ri-search-eye-line', count: '1600+', desc: '烧脑反转悬疑佳作' },
  { label: '科幻片', icon: 'ri-rocket-line', count: '1400+', desc: '震撼视效科幻巨制' },
  { label: '电视剧', icon: 'ri-tv-line', count: '5000+', desc: '热门高清电视剧全集' },
  { label: '纪录片', icon: 'ri-film-line', count: '900+', desc: '精彩纪实高清纪录' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              分类索引
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              按类型快速找到你想看的高清影视内容
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
            {indexItems.map((item, i) => (
              <div
                key={i}
                className="flex flex-col items-center text-center p-4 md:p-5 bg-background-100 rounded-xl border border-background-200/70 hover:border-accent-300/40 hover:bg-accent-50/30 transition-all cursor-pointer group"
              >
                <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-3 group-hover:bg-accent-500 group-hover:text-background-50 transition-all">
                  <i className={`${item.icon} text-lg md:text-xl`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">{item.label}</h3>
                <span className="text-xs font-bold text-accent-600 mb-1">{item.count}</span>
                <span className="text-xs text-foreground-500">{item.desc}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}